const Config = {
    resAddr:"https://media2.isagzth.com/parent-weapp/weixin/",    //资源服务器
    //backendUrl:"https://api2.isagzth.com/",
    backendUrl:"https://login.isagzth.com/",
    defaultMainImg:"https://media.isagzth.com/isa-weapp/weixin/defaultMain.jpg",
}

export default Config;
